import { Grid } from "@mui/material";
import { ReactComponent as NoDataIcon } from "assets/images/icons/noData.svg";
import React from "react";
import Typographys from "components/common-component/typography";
import { makeStyles } from "@mui/styles";
const useStyle = makeStyles((theme) => ({
hrMainDiv:{
  textAlign: "center", 
  margin: "25px 0px" 
},
hrNODataIcon:{
  width: "150px",
  height: "150px" 
}
 
}));


export default function NoDataFound({ props }) {
  const classes = useStyle();
  return (
    <Grid className={classes.hrMainDiv}>
      <NoDataIcon className={classes.hrNODataIcon} />
      <Typographys>No Record Found</Typographys>
    </Grid>
  );
}
